import { Box, Icon, PressableOverlay, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import ShopSaleBanners from '../ShopSaleBanners/ShopSaleBanners';
import { memo, useCallback, useMemo } from 'react';
import ShopFilterItemList from '../ShopFilterItemList/ShopFilterItemList';
import { useShopRouteParams, useShopFilterName } from '../../hooks';
import { BottomSheet } from '@bonanza-social/navigation';
import { SetShopSortParamType } from '../../state/types';

function ShopItemListHeader() {
  const [t] = useTranslation('shop');
  const { filterParam, sortParam, setSortParam } = useShopRouteParams();
  const filterName = useShopFilterName(filterParam);

  const title = useMemo(
    () =>
      filterName
        ? t('shopFilterItemsTitle', {
            filter: filterName,
            interpolation: { escapeValue: false },
          })
        : t('shopAllItemsTitle'),
    [filterName, t],
  );

  const onSort: SetShopSortParamType = useCallback(
    (value) => setSortParam(value),
    [setSortParam],
  );

  const openSortBottomSheet = useCallback(() => {
    BottomSheet.open({
      namespace: 'shop',
      type: 'ShopSort',
      titleNS: 'shop',
      titleKey: 'shopSortBy',
      light: false,
      data: {
        sortParam,
        onSort,
      },
    });
  }, [sortParam, onSort]);

  return (
    <Box gap="space-600">
      <ShopSaleBanners />
      <ShopFilterItemList />
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
        paddingHorizontal="space-400"
        gap="space-100"
      >
        <Box flexWrap="wrap" flex={1}>
          <Text variant="h6" gradient="darkSurfaceAccent">
            {title}
          </Text>
        </Box>
        <Box flexDirection="row" alignItems="center" gap="space-100">
          <Icon
            name="sortArrows"
            gradient="accentBackground"
            width="space-400"
            height="space-400"
          />
          <Text
            variant="body-s-semi"
            locNS="shop"
            locKey={`shopSort${sortParam}`}
            gradient="darkSurfaceAccent"
          />
          <PressableOverlay onPress={openSortBottomSheet} />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(ShopItemListHeader);
